module.exports = __webpack_public_path__ + "img/sort12.bd009a37.jpg";